import { makeAutoObservable } from "mobx";
import { Product, ProductListParams } from "../../models/Product"; 
import { ProductApi } from "../../apis/Product";

export class ProductManagementPageModel {
    products: Product[] = [];
    searchText: string = "";
    selectedStatus: number | undefined = undefined;
    sortField: string = "onlineTime";
    sortOrder: "asc" | "desc" = "desc";
    selectedProduct: Product | null = null;
    showDetailModal: boolean = false;

    constructor() {
        makeAutoObservable(this);
    }

    setSearchText = (text: string) => {
        this.searchText = text;
    }

    setSelectedStatus = (status: number | undefined) => {
        this.selectedStatus = status;
    }

    setSortField = (field: string) => {
        this.sortField = field;
    }

    setSortOrder = (order: "asc" | "desc") => {
        this.sortOrder = order;
    }

    resetFilters = () => {
        this.searchText = "";
        this.selectedStatus = undefined;
        this.sortField = "onlineTime";
        this.sortOrder = "desc";
    }

    showProductDetail = (product: Product) => {
        this.selectedProduct = product;
        this.showDetailModal = true;
    }

    closeDetailModal = () => {
        this.showDetailModal = false;
        this.selectedProduct = null;
    }

    loadProducts = async () => {
        const params: ProductListParams = {
            searchText: this.searchText,
            status: this.selectedStatus,
            sortField: this.sortField,
            sortOrder: this.sortOrder
        };

        const response = await ProductApi.getProductList(params);
        this.products = response.products;
    }

    forceOffline = async (productId: string, reason: string) => {
        const success = await ProductApi.forceOfflineProduct({
            productId,
            reason
        });

        if (success) {
            await this.loadProducts();
        }
        return success;
    }
} 